import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const joinOptions = [
  {
    type: '我的新朋友',
    title: '我想參與相信世代社群活動',
    icon: 'Smile',
    color: 'bg-blue-50 text-blue-600 border-blue-100',
    btnColor: 'bg-blue-600 hover:bg-blue-700'
  },
  {
    type: '我是企業',
    title: '企業 CSR / ESG 合作',
    icon: 'Briefcase',
    color: 'bg-emerald-50 text-emerald-600 border-emerald-100',
    btnColor: 'bg-emerald-600 hover:bg-emerald-700'
  },
  {
    type: '我是屋主',
    title: '成為公益出租人',
    icon: 'Home',
    color: 'bg-amber-50 text-amber-600 border-amber-100',
    btnColor: 'bg-amber-600 hover:bg-amber-700'
  },
  {
    type: '我想加入相信世代',
    title: '成為影響力夥伴',
    icon: 'Heart',
    color: 'bg-rose-50 text-rose-600 border-rose-100',
    btnColor: 'bg-rose-600 hover:bg-rose-700'
  }
];

const JoinUs = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">一起相信世代</h2>
          <p className="text-xl text-gray-600">找到適合你的參與方式，與我們共同創造改變。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {joinOptions.map((option, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`rounded-2xl p-8 border hover:shadow-lg transition-all duration-300 flex flex-col h-full ${option.color.split(' ')[0]} ${option.color.split(' ')[2]}`}
            >
              <div className={`w-14 h-14 rounded-full bg-white shadow-sm flex items-center justify-center mb-6 text-2xl ${option.color.split(' ')[1]}`}>
                <SafeIcon name={option.icon} />
              </div>
              <div className="text-sm font-bold tracking-wider uppercase mb-2 opacity-70">
                {option.type}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-8 flex-grow">
                {option.title}
              </h3>
              <button className={`w-full py-3 px-4 rounded-xl text-white font-medium transition-colors ${option.btnColor}`}>
                立即行動
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JoinUs;